/*路由的管理*/

import { createRouter, createWebHistory } from 'vue-router'
import Layout from '../layout/Layout.vue'//记得更换路径

const routes = [
  {
    //默认访问界面
    path: '/',
    name: 'Layout',//框架界面，当我们访问斜杠时、其实是在访问Layout
    component: Layout,
    //重定向，实现路由的自动跳转,当我访问/时，会自动帮我跳转到/user
    redirect:"/homePage",
    //需要再写一个嵌套路由访问Home
    //children是一个数组，可以放很多个路由以供嵌套使用
    // children:[
    //   {
    //     path: '/personInformation',
    //     name: 'PersonInformation',
    //     component: ()=>import("@/views/PersonInformation")
    //   },
    // ]
  },
  // {
  //   path: '/login',
  //   name: 'Login',
  //   //如何将Login导入界面中
  //   component: ()=>import("@/login_register/Login")
  // },
  {
    path: '/homePage',
    name: 'HomePage',
    component: ()=>import("@/views/HomePage"),
    children: [
      {
        path: '/mainPage',
        name: 'MainPage',
        component: ()=>import("@/views/MainPage")
      },
      {
        path: '/aboutUs',
        name: 'AboutUs',
        component: ()=>import("@/views/AboutUs")
      },
      {
        path: '/immigrate_infor1',
        name: 'Immigrate_infor1',
        component: ()=>import("@/views/Immigrate_infor1")
      },
      {
        path: '/immigrate_infor2',
        name: 'Immigrate_infor2',
        component: ()=>import("@/views/Immigrate_infor2")
      },
      {
        path: '/immigrate_infor2',
        name: 'Immigrate_infor2',
        component: ()=>import("@/views/Immigrate_infor2")
      },
      {
        path: '/immigrate_infor3',
        name: 'Immigrate_infor3',
        component: ()=>import("@/views/Immigrate_infor3")
      },
      {
        path: '/immigrate_infor4',
        name: 'Immigrate_infor4',
        component: ()=>import("@/views/Immigrate_infor4")
      },
      {
        path: '/immigrate_infor5',
        name: 'Immigrate_infor5',
        component: ()=>import("@/views/Immigrate_infor5")
      },
      {
        path: '/immigrate_infor6',
        name: 'Immigrate_infor6',
        component: ()=>import("@/views/Immigrate_infor6")
      },
      {
        path: '/immigrate_infor7',
        name: 'Immigrate_infor7',
        component: ()=>import("@/views/Immigrate_infor7")
      },
      {
        path: '/immigrate_infor8',
        name: 'Immigrate_infor8',
        component: ()=>import("@/views/Immigrate_infor8")
      },
      {
        path: '/education',
        name: 'Education',
        component: ()=>import("@/views/Education")
      },
      {
        path: '/education_lev1_intern',
        name: 'Education_lev1_intern',
        component: ()=>import("@/views/Education_lev1_intern")
      },
      {
        path: '/education_lev1_prim',
        name: 'Education_lev1_prim',
        component: ()=>import("@/views/Education_lev1_prim")
      },
      {
        path: '/education_lev1_second',
        name: 'Education_lev1_second',
        component: ()=>import("@/views/Education_lev1_second")
      },
      {
        path: '/education_lev1_univer',
        name: 'Education_lev1_univer',
        component: ()=>import("@/views/Education_lev1_univer")
      },
      {
        path: '/education_lev2',
        name: 'Education_lev2',
        component: ()=>import("@/views/Education_lev2")
      },
      {
        path: '/education_lev2_undergrad',
        name: 'Education_lev2_undergrad',
        component: ()=>import("@/views/Education_lev2_undergrad")
      },
      {
        path: '/education_lev2_postgrad',
        name: 'Education_lev2_postgrad',
        component: ()=>import("@/views/Education_lev2_postgrad")
      },
      {
        path: '/education_lev2_phd',
        name: 'Education_lev2_phd',
        component: ()=>import("@/views/Education_lev2_phd")
      },
      {
        path: '/english',
        name: 'English',
        component: ()=>import("@/views/English")
      },
      {
        path: '/cooperation',
        name: 'Cooperation',
        component: ()=>import("@/views/Cooperation")
      },
      {
        path: '/contact',
        name: 'Contact',
        component: ()=>import("@/views/Contact")
      },
    ]
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
